import img1 from "../../assets/Images/Accounting/Chart of Accounts.png"
import img2 from "../../assets/Images/Accounting/Create Chart of Accounts.png"

export default function ChartOfAccounts() {
    return (
        <section id="chart-of-accounts" className="space-y-16">

            {/* HEADER / OVERVIEW (STANDARD PATTERN) */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    2. Chart of Accounts
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    The Chart of Accounts defines the complete financial structure of the
                    system by organizing all accounts used for transactions and reporting.
                </p>

                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        The Chart of Accounts (COA) is the backbone of the accounting module.
                        It categorizes financial data into Assets, Liabilities, Equity,
                        Income, and Expenses. Every financial transaction in EventFlow
                        references one or more accounts from this list.
                    </p>
                </section>
            </section>

            {/* ACCOUNT LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Chart of Accounts List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Chart of Accounts module is opened, a table displays all
                        configured accounts with their classifications.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Account Code (unique identifier)</li>
                        <li>Account Name</li>
                        <li>Account Type (Asset, Expense, Liability, etc.)</li>
                        <li>Group indicator (Yes / No)</li>
                        <li>Parent account (if grouped)</li>
                        <li>Status (Active / Inactive)</li>
                        <li>Actions (Edit, Delete)</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD ACCOUNT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Creating a New Account
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add New</strong> button opens the Create Account
                    form where a new ledger account can be defined.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Account Name:</strong> Descriptive name of the account
                    </li>
                    <li>
                        <strong>Account Code:</strong> Unique numeric or alphanumeric code
                    </li>
                    <li>
                        <strong>Account Type:</strong> Asset, Liability, Equity, Income, or Expense
                    </li>
                    <li>
                        <strong>Balance Type:</strong> Debit or Credit
                    </li>
                    <li>
                        <strong>Is Group:</strong> Define whether the account is a parent group
                    </li>
                    <li>
                        <strong>Parent Account:</strong> Optional grouping under a parent
                    </li>
                    <li>
                        <strong>Status:</strong> Active or Inactive
                    </li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Click <strong>Create</strong> to save the account or
                    <strong> Reset</strong> to clear the form.
                </p>

                <div className="rounded-lg p-4 mt-4">
                  <img src={img2} alt="" />
                </div>
            </section>

            {/* EDIT & DELETE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Managing Accounts
                </h3>

                <p className="text-slate-600 mb-4">
                    Existing accounts can be maintained using the available actions.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Edit:</strong> Update account name, type, grouping, or status
                    </li>
                    <li>
                        <strong>Delete:</strong> Remove unused or incorrectly created accounts
                    </li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Deleting an account should be done carefully to avoid breaking financial
                    references.
                </p>
            </section>

            {/* ACCOUNTING IMPORTANCE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why the Chart of Accounts Is Critical
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    A well-structured Chart of Accounts ensures accurate reporting,
                    consistent ledger balances, and reliable financial statements. All
                    accounting modules — including journal entries, ledgers, trial balance,
                    profit & loss, and balance sheet — depend on this structure.
                </p>
            </section>

        </section>
    );
}
